exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".switch label input#profile-switch-input[type=checkbox]:checked+#profile-switch-lever.lever[data-v-094707e5]:after{background-color:#8344e9}.switch label input[type=checkbox]:checked+.lever[data-v-094707e5]{background-color:#d0b3ff}td[data-v-094707e5]{padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-094707e5","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Ad.vue
// module id = 261
// module chunks = 0